import { render, staticRenderFns } from "./dingTalk.vue?vue&type=template&id=709bd2a3&"
import script from "./dingTalk.vue?vue&type=script&lang=js&"
export * from "./dingTalk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports